import type { ThemeConfig } from "../types";
import { MidnightVelvetScene } from "./Scene";

export const midnightVelvet: ThemeConfig = {
  id: "midnight-velvet",
  name: "Midnight Velvet",
  tagline: "Moonlit cathedral, oxblood velvet road, dark unicorn",
  brandLabel: "Midnight Velvet",
  tokens: {
    bg: "#0b0710",
    bgElevated: "rgba(255, 255, 255, 0.035)",
    bgPanel: "rgba(11, 6, 18, 0.86)",
    bgOverlay: "rgba(5, 2, 10, 0.92)",

    fg: "#ece6f0",
    fgMuted: "rgba(214, 200, 224, 0.6)",
    fgStrong: "#f6efff",
    fgInverse: "#0b0710",

    accent: "#b91c47",
    accentSoft: "rgba(185, 28, 71, 0.18)",
    accent2: "#c8b8d6",
    accent2Soft: "rgba(200, 184, 214, 0.16)",
    accentRainbow:
      "linear-gradient(110deg, #6b1029 0%, #b91c47 18%, #5b2e63 38%, #c8b8d6 56%, #e2a85c 72%, #2a0c1a 88%, #6b1029 100%)",

    border: "rgba(236, 230, 240, 0.12)",
    borderSoft: "rgba(236, 230, 240, 0.06)",
    borderStrong: "rgba(200, 184, 214, 0.42)",

    positive: "#8aaf8e",
    negative: "#d4365e",
    warning: "#e2a85c",

    bankPanelBg:
      "linear-gradient(180deg, rgba(91, 46, 99, 0.32) 0%, rgba(11, 6, 18, 0.78) 48%, rgba(185, 28, 71, 0.22) 100%)",
    bankPanelBorder: "rgba(200, 184, 214, 0.32)",
    bankPanelHeading: "#f6efff",

    fontDisplay: "'Cormorant Garamond', 'Cormorant Unicase', 'Times New Roman', serif",
    fontBody: "'Inter', system-ui, sans-serif",
    fontMono: "'JetBrains Mono', 'DM Mono', ui-monospace, monospace",

    decorationGlow:
      "0 22px 70px rgba(185, 28, 71, 0.28), 0 0 38px rgba(200, 184, 214, 0.18)"
  },
  assets: {
    mascot: "scene:midnight-velvet",
    decorations: [],
    Scene: MidnightVelvetScene,
    bank: {
      // Tarnished amber instead of bright gold — sits between the warning
      // candle-yellow (#e2a85c) and the oxblood accent.
      coinBase: "#c98a3a",
      coinRim: "#3a1c1c",
      coinFill: "rgba(201, 138, 58, 0.32)",
      coinGlow: "rgba(185, 28, 71, 0.28)",
      // Same three-stop palette as the gumballs on the spider web.
      gumballPalette: [
        "#d4365e", // oxblood
        "#c8b8d6", // moonlit silver-violet
        "#9f7aff", // dusk violet
        "#6b1029", // deep velvet
        "#e2a85c", // ember accent
        "#5b2e63"  // bruised mauve
      ],
      gumballRim: "rgba(200, 184, 214, 0.42)",
      gumballFill: "rgba(107, 16, 41, 0.55)",
      gumballGlow: "rgba(159, 122, 255, 0.28)"
    }
  }
};
